@if (user$ | async; as user) {
  <nav class="bg-white main-shadow md:hidden">
    <ul class="flex justify-around px-2 py-2 m-0 list-none">
      @for (item of navItems; track item.route) {
        @if (
          item.roles?.includes(currentRole) &&
          (businessForNav(user)?.kycStatus === KYCStatus.ACTIVE || item.name === "Wallets")
        ) {
          @let isLocked = needsBeneficiarySetup && item.name !== "Home" && item.name !== "Wallets";
          <li
            class="relative flex-1 flex flex-col items-center justify-center px-2 py-2 transition-all duration-200 rounded-xl cursor-pointer"
            #rla="routerLinkActive"
            routerLinkActive
            [routerLink]="isLocked ? null : item.route"
            [ngClass]="{
              'rounded-xl text-primary bg-[#ECF0FF]': rla.isActive,
              'text-[#434A60]': !rla.isActive && !isLocked,
              'text-gray-300': isLocked,
            }"
            (click)="onNavItemClick(item)"
          >
            <img class="w-[18px] h-[18px] mb-1" [src]="rla.isActive ? item.iconActive : item.icon" [style.opacity]="isLocked ? '0.35' : '1'" [alt]="item.name" />
            @if (item.name === "Updates") {
              <span class="flex items-center justify-center gap-1 text-xs font-medium relative">
                {{ item.name }}
                @if ((conversations$ | async | countUnreadMessages) > 0) {
                  <nz-badge class="absolute -top-1 -right-1" [nzCount]="conversations$ | async | countUnreadMessages" [nzSize]="'small'"></nz-badge>
                }
              </span>
            } @else {
              <span class="text-xs font-medium">{{ item.name }}</span>
            }
          </li>
        }
      }
    </ul>
  </nav>
}
